import {
	Grid,
	Card,
	CardContent,
	IconButton,
	useMediaQuery,
	Divider,
	Button,
	Typography,
	Box,
	List,
	Avatar,
	ListItem,
	ListItemText,
	ListItemAvatar,
	Skeleton,
	Fade,
	ClickAwayListener,
	Popper,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLoaderData } from '@remix-run/react';
import { Link } from '@remix-run/react';
import { alpha, useTheme } from '@mui/material/styles';

const Contact_redirect = (props: any): JSX.Element => {
	const { userLanguage } = useLoaderData();
	const link_prefix = userLanguage === 'en' ? '/en' : '';
	let { t } = useTranslation(['common']);

	const theme = useTheme();
	// const isSm = useMediaQuery(theme.breakpoints.down('sm'), {
	// 	defaultMatches: true,
	// });
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});

	return (
		<Box>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<Typography
					fontWeight={700}
					component='h3'
					variant='h4'
					gutterBottom
					align={'center'}
					color={'text.primary'}
					// sx={{
					// 	textDecoration: '#FF6600 underline',
					// 	textUnderlineOffset: '5px',
					// 	textDecorationThickness: '2px',
					// }}
				>
					{t('mini_contact_redirect_headline')}
				</Typography>
			</Box>

			<Typography variant={'h6'} component={'p'} color={'text.secondary'} align={'center'}>
				{t('mini_contact_redirect_subheadline')}
			</Typography>

			<Box
				display={'flex'}
				marginTop={{ xs: 4, sm: 6 }}
				marginBottom={{ xs: 0, sm: 2 }}
				flexDirection={{ xs: 'column', sm: 'row' }}
				rowGap={2}
				columnGap={2}
				justifyContent={'center'}
				alignItems={'center'}
			>
				<Link
					to={link_prefix + '/' + props.leftButtonLink}
					prefetch='intent'
					style={{
						textDecoration: 'none',
						width: isMd ? 'auto' : '100%',
					}}
					onClick={(e) => {
						e.stopPropagation();
						// e.preventDefault();
					}}
				>
					<Button
						sx={{
							borderRadius: '0',
							textAlign: 'center',
							width: '100%',
						}}
						// href={link_prefix + '/hire-us/'}
						variant='contained'
						color='primary'
						size='large'
					>
						{/* {t('mini_contact_button')} */}
						{props.leftButtonText}
					</Button>
				</Link>
				<Link
					to={link_prefix + '/references/'}
					prefetch='intent'
					style={{
						textDecoration: 'none',
						width: isMd ? 'auto' : '100%',
					}}
					onClick={(e) => {
						e.stopPropagation();
						// e.preventDefault();
					}}
				>
					<Button
						sx={{
							borderRadius: '0',
							textAlign: 'center',
							width: '100%',
						}}
						variant='outlined'
						color='primary'
						size='large'
						// href={link_prefix + '/contact/?scrollTo=video-call'}
					>
						{t('mini_contact_button_right')}
					</Button>
				</Link>

				{/* <Button
					component={'a'}
					href={'https://mui.com/store/items/the-front-landing-page/'}
					target={'_blank'}
					variant="contained"
					color="primary"
					size="large"
					endIcon={
						<svg
							width={16}
							height={16}
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
						</svg>
					}
				>
					Projektanfrage stellen
				</Button> */}
			</Box>
		</Box>
	);
};

export default Contact_redirect;
